export const DVTJCUVAcquireCddParentTabs = [
    {title: '1-PRE-EMAIL MỜI', id: 'dvtjcuv-acquire-cdd-pre-email-tab'},
    {title: "2-GỬI EMAIL MỜI", id: 'dvtjcuv-acquire-cdd-email-tab'},
    {title: '3-GỬI EMAIL FU', id: 'dvtjcuv-acquire-cdd-fu-email-tab'},
    {title: '4-XỬ LÝ EMAIL PHẢN HỒI', id: 'dvtjcuv-acquire-cdd-process_feedback-email-tab'},
    {title: '5-UV CẦN CALL CHAT MEET', id: 'dvtjcuv-acquire-cdd-uv-need-call-chat-tab'},
    {title: '6-UV CẦN ME FU', id: 'dvtjcuv-acquire-cdd-uv-need-me-fu-tab'},
    {title: '7-HOT JOB CHƯA CÓ ACTION PLAN', id: 'dvtjcuv-acquire-cdd-hot-job-not-has-plan-tab'},
    {title: '8-UV cần REP', id: 'dvtjcuv-acquire-cdd-uv-need-rep-tab'},
    {title: '9-UV TẠM DỪNG Process', id: 'dvtjcuv-acquire-cdd-pending-process-tab'},
    {title: '10-UV HẾT HẠN DV', id: 'dvtjcuv-acquire-cdd-service-expire-tab'},
]

export const DVTJCUVAcquireCddParentTabIds = {
    PRE_EMAIL_TAB: 'dvtjcuv-acquire-cdd-pre-email-tab',
    EMAIL_TAB: 'dvtjcuv-acquire-cdd-email-tab',
    FU_EMAIL_TAB: 'dvtjcuv-acquire-cdd-fu-email-tab',
    PROCESS_FEEDBACK_EMAIL_TAB: 'dvtjcuv-acquire-cdd-process_feedback-email-tab',
    UV_NEED_CALL_CHAT_TAB: 'dvtjcuv-acquire-cdd-uv-need-call-chat-tab',
    UV_NEED_ME_FU_TAB: 'dvtjcuv-acquire-cdd-uv-need-me-fu-tab',
    HOT_JOB_NOT_HAS_PLAN_TAB: 'dvtjcuv-acquire-cdd-hot-job-not-has-plan-tab',
    UV_NEED_REP_TAB: 'dvtjcuv-acquire-cdd-uv-need-rep-tab',
    PENDING_PROCESS_TAB: 'dvtjcuv-acquire-cdd-pending-process-tab',
    SERVICE_EXPIRE_TAB: 'dvtjcuv-acquire-cdd-service-expire-tab'
}

export const DVTJCUVAcquireCddSendEmailTabs = [
    {title: '2.1-Duyệt Draft & Gửi email', id: 'draft-tab'},
    {title: "2.2-Person bạn chưa có quyền gửi email", id: 'not-permission-email-tab'},
    {title: '2.3-Person need checking', id: 'need-checking-tab'},
    {title: "2.4-Person cần nhập bổ sung ttin", id: 'need-input-info-tab'},
    {title: "2.5-Person chờ hạn mức", id: 'send-when-unlimited-tab'},
    {title: "2.6-Person đã export", id: 'exported-waiting-send-email-tab'}
]

export const DVTJCUVAcquireCddSendEmailTabIds = {
    APPROVE_DRAFT: 'draft-tab',
    NOT_PERMISSION_EMAIL: 'not-permission-email-tab',
    NEED_CHECKING: 'need-checking-tab',
    NEED_INPUT_INFO: 'need-input-info-tab',
    SEND_WHEN_UNLIMITED: 'send-when-unlimited-tab',
    EXPORTED_WAITING_SEND_EMAIL: 'exported-waiting-send-email-tab'
}

export const DVTJCUVAcquireCddEmailFUTabs = [
    {title: '3.1-Duyệt Draft & Gửi email', id: 'fu-draft-tab'},
    {title: "3.2-Person bạn chưa có quyền gửi email", id: 'fu-not-permission-email-tab'},
    {title: '3.3-Person need checking', id: 'fu-need-checking-tab'},
    {title: "3.4-Person cần nhập bổ sung ttin", id: 'fu-need-input-info-tab'},
    {title: "3.5-Person chờ hạn mức", id: 'fu-send-when-unlimited-tab'},
    {title: "3.6- UV đã export, chờ NL Gửi email mời job", id: 'fu-exported-waiting-send-email-tab'}
]

export const DVTJCUVAcquireCddEmailFUTabIds = {
    APPROVE_DRAFT: 'fu-draft-tab',
    NOT_PERMISSION_EMAIL: 'fu-not-permission-email-tab',
    NEED_CHECKING: 'fu-need-checking-tab',
    NEED_INPUT_INFO: 'fu-need-input-info-tab',
    SEND_WHEN_UNLIMITED: 'fu-send-when-unlimited-tab',
    EXPORTED_WAITING_SEND_EMAIL: 'fu-exported-waiting-send-email-tab'
}

export const DVTJCUVAcquireCddPreEmailTabs = [
    {title: 'Hot job chưa tiếp cận', id: 'hot-job-not-approached-tab'},
    {title: 'TARGETED > to Email', id: 'targeted-to-email-tab'},
    {title: 'TARGETED, CHƯA CÓ Email', id: 'targeted-not-have-email-tab'},
    {title: 'UV có EMAIL MỚI', id: 'uv-has-new-email-tab'},
]

export const DVTJCUVAcquireCddPreEmailTabIds = {
    HOT_JOB_NOT_APPROACHED: 'hot-job-not-approached-tab',
    TARGETED_TO_EMAIL: 'targeted-to-email-tab',
    TARGETED_NOT_HAVE_EMAIL: 'targeted-not-have-email-tab',
    UV_HAS_NEW_EMAIL: 'uv-has-new-email-tab',
}

export const DVTJCUVAcquireCddUVNeedCallChatTabs = [
    {title: '5.1-Agreement done', id: 'agreement-done-tab'},
    {title: '5.2-Potential', id: 'potential-tab'},
    {title: '5.3-Chưa liên lạc được', id: 'unable-contact-tab'},
    {title: '5.4-Chờ Cdd', id: 'waiting-cdd-tab'},
    {title: '5.5-Cdd từ chối', id: 'cdd-rejected-tab'},
    {title: '5.6-Others', id: 'others-tab'},
]

export const DVTJCUVAcquireCddUVNeedCallChatTabIds = {
    AGREEMENT_DONE: 'agreement-done-tab',
    POTENTIAL: 'potential-tab',
    UNABLE_CONTACT_TAB: 'unable-contact-tab',
    waiting_cdd_tab: 'waiting-cdd-tab',
    CDD_REJECTED_TAB: 'cdd-rejected-tab',
    OTHERS: 'others-tab',
}

export const DVTJCUVAcquireCddUVNeedMeFUTabs = [

]

export const DVTJCUVAcquireCddUVNeedMeFUTabIds = {

}


